//minimum pixel threshhold before considering the gesture dragging
const DX = 5;

let isDragging = false;
let isMouseDown = false;

let currentDragCountainerId = null;
let nextDragContainerId = 1;

let nextDragId = 1;
let currentDragId = null;

let currentDraggedElement = null;
let scrollMultiplier = 1;
let startX, scrollLeft;

const onMouseDown = (e) => {
  const element = e.target;
  const isScrollable = element.getAttribute("scrollable") !== null;
  if (!isScrollable) {
    return;
  }

  const scrollContainer = element.parentNode;
  const isParentScrollContainer =
    scrollContainer.getAttribute("scroll-container") !== null;
  if (!isParentScrollContainer) {
    return;
  }

  isMouseDown = true;

  populateDragContainerId(scrollContainer);
  populateDragId(element);

  const scrollMultiplierValue = Number.parseFloat(
    scrollContainer.getAttribute("scroll-multiplier"),
  );
  scrollMultiplier = scrollMultiplierValue || 1;

  startX = e.pageX - scrollContainer.offsetLeft;
  scrollLeft = scrollContainer.scrollLeft;
};

function populateDragContainerId(element) {
  if (!element.hasAttribute("drag-container-id")) {
    element.setAttribute("drag-container-id", nextDragContainerId);
    currentDragCountainerId = nextDragContainerId;
    nextDragContainerId++;
    return;
  }

  currentDragCountainerId = Number.parseInt(
    element.getAttribute("drag-container-id"),
  );
}

function populateDragId(element) {
  if (!element.hasAttribute("drag-id")) {
    element.setAttribute("drag-id", nextDragId);
    currentDragId = nextDragId;
    nextDragId++;
    return;
  }

  currentDragId = Number.parseInt(element.getAttribute("drag-id"));
}

const onMouseUp = (e) => {
  if (!currentDragId) {
    //did not start scrolling
    return;
  }

  if (!currentDraggedElement) {
    emulateOnClick(e);
  }

  if (currentDraggedElement) {
    currentDraggedElement.classList.remove("isDragging");
  }
  isDragging = false;
  isMouseDown = false;
  currentDragId = null;
  currentDraggedElement = null;
};

function emulateOnClick(e) {
  const dragId = Number.parseInt(e.target.getAttribute("drag-id"));
  if (dragId !== currentDragId) {
    return;
  }

  const insideAnchor = document.querySelector(`[drag-id="${currentDragId}"] a`);

  if (insideAnchor) {
    insideAnchor.click();
    return true;
  }

  const outsideAnchor = document.querySelector(
    `[drag-container-id="${currentDragCountainerId}"] a [drag-id="${currentDragId}"]`,
  );

  if (outsideAnchor) {
    outsideAnchor.click();
    return true;
  }
}

const move = (e) => {
  if (!isMouseDown) {
    return;
  }

  if (!isDragging) {
    isDragging = Math.abs(startX - e.clientX) > DX;
  }

  if (isDragging) {
    if (!currentDraggedElement) {
      currentDraggedElement = document.querySelector(
        `[drag-container-id="${currentDragCountainerId}"]`,
      );
      currentDraggedElement.classList.add("isDragging");
    }

    const x = e.pageX - currentDraggedElement.offsetLeft;
    const scroll = x - startX;
    /* currentDraggedElement.scroll({
      left: scrollLeft - scroll * scrollMultiplier,
      behavior: "smooth",
    }); */
    currentDraggedElement.scrollLeft = scrollLeft - scroll * scrollMultiplier;
  }
};

document.addEventListener("mousedown", onMouseDown);
document.addEventListener("mouseup", onMouseUp);
document.addEventListener("mousemove", move);
// Add this at the top of your file
document.addEventListener("DOMContentLoaded", () => {
  // Reset all scroll containers to start position
  document.querySelectorAll("[scroll-container]").forEach((container) => {
    if (container.scrollLeft !== 0) {
      container.scrollTo({
        left: 0,
        behavior: "instant",
      });
    }
  });
});
